import PropTypes from "prop-types";
import { useAuthDataContext } from "components/auth";

const RestrictedToScopedView = ({ fallback = null, children }) => {
  const { user } = useAuthDataContext();
  return user && user.scopedViewByCustomer ? children : fallback;
};

RestrictedToScopedView.propTypes = {
  /**
   * Fallback si el usuario no tiene acceso, por defecto null
   */
  fallback: PropTypes.element,
};

export default RestrictedToScopedView;
